<template>
    <button type="button" class="timesheet-keyboard-cell timesheet-month-cell-button"
        :data-line-id="line.id" :data-work-date="date" :title="description || null" :aria-label="`${line.employee_name_snapshot}, ${date}: ${api.monthCellDisplay(line, date) || 'пусто'}${description ? '. ' + description : ''}`"
        @click="selectionOnly ? api._cellPicker && api._cellPicker.openFor(line, date) : api.openDay(date)"><slot>{{ api.monthCellDisplay(line, date) }}</slot></button>
</template>
<script>
export default {
    name: 'TimesheetReadCell',
    props: {api: {type: Object, required: true}, line: {type: Object, required: true}, date: {type: String, required: true}, selectionOnly: Boolean, description: String},
    mounted() { this.register(); },
    updated() { this.register(); },
    beforeDestroy() { this.unregister(); },
    methods: {
        register() {
            const key = this.api.cellKey(this.line.id, this.date);
            if (this._key && this._key !== key) this.unregister();
            this._key = key;
            if (this.api._cellPicker) this.api._cellPicker.register(key, this.$el);
        },
        unregister() { if (this.api._cellPicker) this.api._cellPicker.unregister(this._key, this.$el); }
    }
};
</script>
<style scoped>
.timesheet-keyboard-cell { cursor: crosshair; }
</style>
